import { connectProductOrderLabel } from './connectProductOrderLabel';
import { ProductOrderLabel as ProductOrderLabelPure } from './ProductOrderLabel';

export const ProductOrderLabel = connectProductOrderLabel(ProductOrderLabelPure);
